import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoadingState, NodeBuilder} from "../../../../../../../shared/models";
import {Authenticate, NODE_TYPE} from "./authenticate";
import {MatButtonToggleGroup} from "@angular/material/button-toggle";
import {FormArray, FormControl} from "@angular/forms";
import {hasDuplicates, required, spaceOnName} from "../../../../../../../shared/utils";
import {getEditTypes} from "../../../delegatorUtils";
import {tap} from "rxjs/operators";
import {FlowManagerService} from "../../../../../services/flow-manager.service";
import {Subscription} from "rxjs";

@Component({
    selector: 'app-authenticate',
    templateUrl: './authenticate.component.html',
    styleUrls: ['./authenticate.component.scss']
})
export class AuthenticateComponent extends NodeBuilder implements OnInit, OnDestroy {

    readonly SCOPE_FIELD = {
        placeholder: 'Add Scope(s)',
    };

    private authenticate: Authenticate;
    public idpList: { name: string; createdTime: number; id: string; status: number }[];

    public loadingState: LoadingState;
    private idpListSubscription: Subscription;

    constructor(private flowManagerService: FlowManagerService) {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
        this.authenticate = new Authenticate();
        this.getIdpList();
    }

    ngOnDestroy(): void {
        this.idpListSubscription?.unsubscribe()
    }

    set buildForm(stepData: any) {
        this.formGroup = this.authenticate.toForm(stepData, this.canEdit)
        this.setAllNextStepValues = ['successNext', 'errorNext'];
    }

    get getStepData(): {} {
        this.authenticate.setNodeData(this.formGroup.getRawValue());
        return this.authenticate.nodeData;
    }

    get isNodeValid(): boolean {
        this.formGroup.markAllAsTouched();

        if (this.loadingState !== LoadingState.SUCCESS) {
            return false;
        }
        return this.formGroup.valid;
    }

    setImage(ref: string) {
        this.formGroup.get('imageRef').setValue(ref);
    }

    getIdpList() {
        this.loadingState = LoadingState.LOADING;
        this.idpListSubscription = this.flowManagerService.getIdpList(true).pipe(
            tap((resp: any) => {
                    if (resp.status === 200) {
                        this.loadingState = LoadingState.SUCCESS;
                        this.idpList = resp.body;
                    } else {
                        this.loadingState = LoadingState.ERROR;
                    }
                }
            )
        ).subscribe(() => {
        }, () => {
            this.loadingState = LoadingState.ERROR;
        })
    }


    actionTypeChanged(event: MatButtonToggleGroup) {
        switch (event.value) {
            case 'authenticate':
                this.addToForm();
                break;
            case 'logout':
                this.removeFromForm();
                break
        }
    }

    private addToForm(): void {
        const {editFlows} = getEditTypes(this.canEdit);
        this.formGroup.addControl("nScope", new FormArray([], [required("Scope"), hasDuplicates()]))

        this.formGroup.addControl("responseType", new FormControl({
            value: "",
            disabled: !editFlows,
        }, [required("Response Type"), spaceOnName("Response Type can`t contain space")]))

        this.formGroup.addControl("mandatoryAuthenticate", new FormControl({
            value: "",
            disabled: !editFlows,
        }))
    }

    private removeFromForm(): void {
        this.formGroup.removeControl("nScope");
        this.formGroup.removeControl("responseType");
        this.formGroup.removeControl("mandatoryAuthenticate");
    }
}
